import { get_ } from "./base"

export async function getAnnouncementList(payload: any) {
  const params = Object.keys(payload || {})
  .filter(key => payload[key] !== undefined && payload[key] !== null)
  .map(key => `${key}=${payload[key]}`)
  .join('&')
  const res = await get_(`/api/v2/announcements?${params}`)
  return res
}